module.exports = __webpack_public_path__ + "static/media/icon-mydata-bt.eac3b91d.svg";